import { render, staticRenderFns } from "./FlashNewsForm.vue?vue&type=template&id=42f3bcd0&"
import script from "./FlashNewsForm.vue?vue&type=script&lang=ts&"
export * from "./FlashNewsForm.vue?vue&type=script&lang=ts&"
import style0 from "./FlashNewsForm.vue?vue&type=style&index=0&id=42f3bcd0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42f3bcd0')) {
      api.createRecord('42f3bcd0', component.options)
    } else {
      api.reload('42f3bcd0', component.options)
    }
    module.hot.accept("./FlashNewsForm.vue?vue&type=template&id=42f3bcd0&", function () {
      api.rerender('42f3bcd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/flashNews/FlashNewsForm.vue"
export default component.exports